import React from "react";
import { useAppointmentFees } from "../../../hooks/useAppointmentFees";
import { useContext } from "../../../context";
import { FEE_MODAL_TYPE } from "../../Modals/Fee/config";
import { useNoShowNotificationFlow } from "../../../hooks/useNoShowNotificationFlow";

export function NoShow() {
  const { modals } = useContext();
  const { cancelationFee } = useAppointmentFees();
  const notificationFlow = useNoShowNotificationFlow();

  const onMarkNoShow = () => {
    if (cancelationFee) {
      modals.fee.open({
        type: FEE_MODAL_TYPE.noShow,
        cancelationFee,
      });
    } else {
      notificationFlow.start();
    }
  };

  return (
    <button className="new-yellow-btn" onClick={onMarkNoShow}>
      Mark as No Show
    </button>
  );
}
